import React, { Fragment, useRef } from 'react';
import { bool, func, object } from 'prop-types';
import { Dropdown, Menu } from 'antd';

import SvgIcon from '../../svg-icon/';
import { theme, DividerS } from '../../../styles';
import { USER_ROLES } from '../../../api/constants';
import apikoLogoUrl from '../../../static/imgs/apiko.svg';
import { Logo, LogoWrap, LogoText } from './styled-components';
import {
  DropdownContent,
  DropdownAction,
  DropdownItem,
  DropdownList,
} from '../../ui-helpers';


const LogoPopup = (
  onOpenOrganizationSettings,
  onOpenManageUsers,
  onOpenManageEmails,
) => (
  <Menu style={{ padding: 0 }}>
    <DropdownContent width={230}>
      <DropdownList>
        <DropdownItem>
          <DropdownAction onClick={onOpenManageUsers}>
            <SvgIcon type="fillUser" style={{ verticalAlign: 'middle' }} />
            Manage users
          </DropdownAction>
        </DropdownItem>
        <DropdownItem>
          <DropdownAction onClick={onOpenManageEmails}>
            <SvgIcon type="fillMessage" style={{ verticalAlign: 'middle' }} />
            Manage emails
          </DropdownAction>
        </DropdownItem>
        <DropdownItem>
          <DropdownAction onClick={onOpenOrganizationSettings}>
            <SvgIcon
              type="setting"
              style={{ verticalAlign: 'middle', marginLeft: 1 }}
            />
            Organization settings
          </DropdownAction>
        </DropdownItem>
      </DropdownList>
    </DropdownContent>
  </Menu>
);


export const SidebarHeader = ({
  collapsed,
  authorizedUser,
  onOpenManageEmails,
  onOpenManageUsers,
  onOpenOrganizationSettings,
}) => {
  const targetRef = useRef();

  return (
    <Fragment>
      <Dropdown
        overlay={LogoPopup(
          onOpenOrganizationSettings,
          onOpenManageUsers,
          onOpenManageEmails,
        )}
        trigger={['click']}
        placement="bottomRight"
        overlayClassName="sidebar-ant-dropdown"
        getPopupContainer={() => targetRef && targetRef.current}
        disabled={authorizedUser && authorizedUser.role === USER_ROLES.SALES_AGENT}
      >
        <LogoWrap
          collapsed
          innerRef={targetRef}
          plain={authorizedUser && authorizedUser.role === USER_ROLES.SALES_AGENT}
        >
          <Logo
            innerRef={targetRef}
            src={apikoLogoUrl}
            alt="apiko-logo"
          />
          {!collapsed &&
            (
              <Fragment>
                <LogoText>Apiko Software</LogoText>
                <SvgIcon
                  type="arrowDown"
                  color={theme.colors.fontSilverPrimary}
                  hoverColor={theme.colors.fontSilverPrimary}
                />
              </Fragment>
            )
          }
        </LogoWrap>
      </Dropdown>
      <DividerS />
    </Fragment>
  );
};

SidebarHeader.propTypes = {
  collapsed: bool.isRequired,
  authorizedUser: object.isRequired,
  onOpenManageEmails: func.isRequired,
  onOpenManageUsers: func.isRequired,
  onOpenOrganizationSettings: func.isRequired,
};

export default SidebarHeader;



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar-header/index.js